<template>
    <div class="mid-pane">
        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <div class="nav-hold">
                    <div class="back-icon" @click="backButton()">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.1 31.1">
                        <path d="M30.2 16.4H0.9C0.4 16.4 0 16 0 15.5c0-0.5 0.4-0.9 0.9-0.9h29.3c0.5 0 0.9 0.4 0.9 0.9C31.1 16 30.7 16.4 30.2 16.4z" class="a"></path>
                        <path d="M16 31.1c-0.2 0-0.4-0.1-0.6-0.2L0.3 16.2C0.1 16 0 15.8 0 15.5c0-0.2 0.1-0.5 0.3-0.6L15.4 0.3c0.4-0.3 0.9-0.3 1.3 0 0.3 0.4 0.3 0.9 0 1.3L2.2 15.5l14.5 14c0.4 0.3 0.4 0.9 0 1.3C16.5 31 16.2 31.1 16 31.1z"></path>
                    </svg>
                </span>
                    </div>

                    <div class="nav-text">
                        <p class="main">{{getConfirmationPageBody.confirmationType}}</p>
                        <p class="sub">{{getConfirmationPageBody.confirmationTypeSub}}</p>
                    </div>
                </div>
            </div>
            <!-- Intro Text-->

            <div class="row mt-2">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="card mb-4">
                        <div class="card-body">
                            <!--<div class="card-title">Transfer Confirmation</div>-->
                            <div class="card-content">
                                <div class="confirmation-component">

                                    <div class="top">
                                        <div class="row">
                                            <div class="col-lg-7 col-md-7 col-sm-7 col-7">
                                                <div class="left">
                                                    <div class="bank-logo">
                                                        <img v-if="getConfirmationPageBody.transactionType === 'airtime' || getConfirmationPageBody.transactionType === 'mobileData'" :src="getConfirmationPageBody.network.image" alt="">
                                                        <img v-else-if="getConfirmationPageBody.transactionType === 'otherBills'" src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/invoice.png" alt="">
                                                        <img v-else :src="'https://s3.amazonaws.com/rubiesstore/'+getConfirmationPageBody.creditBank.bankcode+'.png'" alt="">
                                                    </div>

                                                    <div v-if="getConfirmationPageBody.transactionType === 'airtime' || getConfirmationPageBody.transactionType === 'mobileData'" class="details">
                                                        <p class="name">Airtime Recharge</p>
                                                        <p class="account-number">{{getConfirmationPageBody.creditAccount}}</p>
                                                        <p class="bank">{{getConfirmationPageBody.network.label}}</p>
                                                    </div>

                                                    <div v-else-if="getConfirmationPageBody.transactionType === 'otherBills'" class="details">
                                                        <p class="name">{{getConfirmationPageBody.creditAccountName}}</p>
                                                        <p class="account-number">{{getConfirmationPageBody.creditAccount}}</p>
                                                        <p class="bank">{{getConfirmationPageBody.biller.value[1]}} - {{getConfirmationPageBody.product.value[1]}}</p>
                                                    </div>

                                                    <div v-else class="details">
                                                        <p class="name">{{getConfirmationPageBody.creditAccountName}}</p>
                                                        <p class="account-number">{{getConfirmationPageBody.creditAccount}}</p>
                                                        <p class="bank">{{getConfirmationPageBody.creditBank.bankname}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-5 col-md-5 col-sm-5 col-5">
                                                <div class="amount">
                                                    <!--<span class="currency">NGN</span>-->
                                                    <span class="currency">&#8358;</span>
                                                    {{ formatAmountRtn(getConfirmationPageBody.amount) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="confirmation-detail-table">

                                        <div class="tbl confirmation">
                                            <table class="confirmation-detail">
                                                <tr class="wn">
                                                    <td>Debit Account</td>
                                                    <td>{{getConfirmationPageBody.debitAcct.accountname}} ({{getConfirmationPageBody.debitAcct.accountno}})</td>
                                                </tr>
                                                <tr class="wn">
                                                    <td>Amount</td>
                                                    <!--<td>NGN 10,000.00</td>-->
                                                    <td>&#8358; {{formatAmountRtn(getConfirmationPageBody.amount)}}</td>
                                                </tr>
                                                <tr class="wn">
                                                    <td v-if="getConfirmationPageBody.transactionType === 'mobileData'">Bundle</td>
                                                    <td v-else-if="getConfirmationPageBody.transactionType === 'otherBills'">Bill</td>
                                                    <td v-else>Bank</td>

                                                    <td v-if="getConfirmationPageBody.transactionType === 'airtime'">Highstreets MFB</td>
                                                    <td v-else-if="getConfirmationPageBody.transactionType === 'mobileData'">{{getConfirmationPageBody.bundle.value.name}}</td>
                                                    <td v-else-if="getConfirmationPageBody.transactionType === 'otherBills'">{{getConfirmationPageBody.biller.value[1]}} - {{getConfirmationPageBody.product.value[1]}}</td>
                                                    <td v-else>{{getConfirmationPageBody.creditBank.bankname}}</td>
                                                </tr>
                                                <tr class="wn">
                                                    <td v-if="getConfirmationPageBody.transactionType === 'airtime' || getConfirmationPageBody.transactionType === 'mobileData'">Network</td>
                                                    <td v-else>Beneficiary</td>
                                                    <td v-if="getConfirmationPageBody.transactionType === 'airtime' || getConfirmationPageBody.transactionType === 'mobileData'">{{getConfirmationPageBody.network.label}}</td>
                                                    <td v-else>{{getConfirmationPageBody.creditAccountName}}</td>
                                                </tr>
                                                <tr class="wn">
                                                    <td v-if="getConfirmationPageBody.transactionType === 'airtime' || getConfirmationPageBody.transactionType === 'mobileData'">Phone Number</td>
                                                    <td v-else-if="getConfirmationPageBody.transactionType === 'otherBills'">{{getConfirmationPageBody.biller.value[2]}}</td>
                                                    <td v-else>Beneficiary Account</td>
                                                    <td>{{getConfirmationPageBody.creditAccount}}</td>
                                                </tr>
                                                <!--<tr class="wn">-->
                                                <!--<td>Narration</td>-->
                                                <!--<td>{{getConfirmationPageBody.narration}}</td>-->
                                                <!--</tr>-->
                                            </table>
                                        </div>

                                        <!--Narration-->
                                        <div v-if="getConfirmationPageBody.showNarration" class="col-md-12 col-sm-12 col-12 form-group mt-3 mb-2 pl-0 pr-0">
                                            <!--<label class="form-label" for="narration">Narration</label>-->
                                            <input
                                                    type="text" class="form-input form-control" id="narration" placeholder="Enter Narration"
                                                    name="narration" v-model="narration"
                                            >
                                        </div>

                                        <div class="save-bene">
                                            <div class="row">
                                                <div class="col-lg-5 col-md-5 col-sm-5 col-5">

                                                    <div class="checkbox-row">
                                                        <div class="checkbox-container">
                                                            <label class="checkbox" for="save-bene">
                                                                <input type="checkbox" id="save-bene"  v-model="savebene">
                                                                <div class="checkbox-box" aria-hidden="true">
                                                                    <div class="checkbox-outer">
                                                                        <div class="checkbox-inner"></div>
                                                                    </div>
                                                                </div>

                                                                <span class="checkbox-label">save beneficiary</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-7 col-7">
                                                    <div v-if="savebene" class="mb-2">
                                                        <input
                                                                type="text" class="form-input form-control" id="alias"
                                                                placeholder="Alias" v-model="alias"
                                                        >
                                                    </div>

                                                    <button @click="openPinModal" class="btn btn-primary btn-xnax push-right">Continue</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <footer-mobile></footer-mobile>
        </div>

        <!--Pin Modal-->
        <ui-modal
                ref="pinModal" transition="scale-up"
                :removeHeader= "true" size="small" @hide="closePinModal"
                align-top :align-top-margin="50"
        >
            <div class="notification-modal sm">
                <div class="head">
                    <div class="logo-hold">
                        <div>
                            <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="modal-body transaction-pin">
                        <div class="alert-box">
                            <div class="row">
                                <div class="col-sm-12">
                                    <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                        {{alert.message}}
                                    </ui-alert>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-sm-12">
                                <div class="pin-component">

                                    <div class="setPinBox">
                                        <div class="pinHolder">
                                            <span class="pinIndex" :class="{'active': passcode.length > 0}"></span>
                                            <span class="pinIndex" :class="{'active': passcode.length > 1}"></span>
                                            <span class="pinIndex" :class="{'active': passcode.length > 2}"></span>
                                            <span class="pinIndex" :class="{'active': passcode.length > 3}"></span>
                                            <span class="pinIndex" :class="{'active': passcode.length > 4}"></span>
                                            <span class="pinIndex" :class="{'active': passcode.length > 5}"></span>
                                        </div>
                                    </div>

                                    <div class="num-pad confirmation-key-pad">
                                        <div class="key-pad">
                                            <div class="key-row">
                                                <div class="key-stroke" @click="tPinInputNo(1)">1</div>
                                                <div class="key-stroke" @click="tPinInputNo(2)">2</div>
                                                <div class="key-stroke" @click="tPinInputNo(3)">3</div>
                                            </div>

                                            <div class="key-row">
                                                <div class="key-stroke" @click="tPinInputNo(4)">4</div>
                                                <div class="key-stroke" @click="tPinInputNo(5)">5</div>
                                                <div class="key-stroke" @click="tPinInputNo(6)">6</div>
                                            </div>

                                            <div class="key-row">
                                                <div class="key-stroke" @click="tPinInputNo(7)">7</div>
                                                <div class="key-stroke" @click="tPinInputNo(8)">8</div>
                                                <div class="key-stroke" @click="tPinInputNo(9)">9</div>
                                            </div>

                                            <div class="key-row">
                                                <div class="key-stroke" @click="clear()">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 487.4 487.4">
                                                        <path d="M438.7 179.1c-3.8 3.6-7.5 7.2-11.1 10.9 -6.2-33.6-19.8-65.6-44.5-94.3 -66.7-77.4-187.1-108.5-275-49.5C30.2 98.6-12.7 197.8 3.4 288.9 21.2 390.4 104.4 484.2 220.3 470.5c63.1-7.4 119.9-38.6 159.6-83.7 0.8-0.7 1.5-1.5 2.3-2.3 0.9-1 1.7-2 2.4-3.1 1.6-2.5 2.8-5.3 3.4-8.3l0.5-2.5c2.7-13.8-7.2-27.7-21.7-30.5 -8.5-1.6-16.9 0.9-23 6.1 -2.4 2-4.4 4.5-5.9 7.3 -0.3 0.6-0.8 1.2-1 1.9 -0.1-0.1-0.3-0.1-0.4-0.2 -39.2 45-98.6 74.4-160.2 63C74.4 399.2 38 282.1 62.2 197.4 83.2 124.3 152.9 50.5 240.3 68.8c52.1 11 105.6 47.6 125.1 96.5 2 5.1 3.8 10.2 5.3 15.4 -7.1-5.9-14.6-11.5-22.4-16.7 -12.3-8-27.7-9.4-38.2 2.1 -8.7 9.5-9.4 28.5 2.9 36.5 16.4 10.8 30.7 23.1 43.2 37 7.5 8.4 14.4 17.5 20.5 27.2 1.3 2.1 2.7 4.3 4 6.5 6.2 10.7 16.1 13.6 25.2 11.7 7.4-0.1 14.6-2.7 18.9-8.5 3-4 6-7.9 9-11.8 3.3-4.3 6.7-8.5 10.1-12.6 11.1-13.5 22.9-26.5 35.8-38.6C504.5 190.4 463.3 156.1 438.7 179.1z"></path>
                                                    </svg>
                                                </div>
                                                <div class="key-stroke" @click="tPinInputNo(0)">0</div>
                                                <div class="key-stroke" @click="backspace()">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                        <path d="M490.7 64H133.1c-7.2 0-13.9 3.6-17.8 9.6L3.5 244.3c-4.6 7.1-4.6 16.3 0 23.4l111.7 170.7c3.9 6 10.7 9.6 17.8 9.6h357.6c11.8 0 21.3-9.6 21.3-21.3V85.3C512 73.6 502.4 64 490.7 64zM469.3 405.3H144.6L46.8 256l97.8-149.3h324.7V405.3z"></path>
                                                        <path d="M198.2 356.4c8.3 8.3 21.8 8.3 30.2 0l70.2-70.2 70.2 70.2c8.3 8.3 21.8 8.3 30.2 0s8.3-21.8 0-30.2L328.8 256l70.2-70.2c8.3-8.3 8.3-21.8 0-30.2s-21.8-8.3-30.2 0l-70.2 70.2 -70.2-70.2c-8.3-8.3-21.8-8.3-30.2 0 -8.3 8.3-8.3 21.8 0 30.2L268.5 256l-70.2 70.2C189.9 334.6 189.9 348.1 198.2 356.4z"></path>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ui-modal>


        <!--UI Modal For Displaying Transfer Success Message-->
        <ui-modal
                ref="transferSuccessModal" transition="scale-up"
                :removeHeader= "true" size="small" @hide="endTransfer"
                align-top :align-top-margin="200"
        >
            <div class="notification-modal sm">
                <div class="head">
                    <div class="logo-hold">
                        <div>
                            <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-2">
                                <div class="left">
                                    <div class="status-icon">
                                        <svg class="success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496.2 496.2">
                                            <path d="M496.2 248.1c0-137-111.1-248.1-248.1-248.1C111.1 0 0 111.1 0 248.1c0 137 111.1 248.1 248.1 248.1C385.1 496.2 496.2 385.1 496.2 248.1z"></path>
                                            <path d="M384.7 165c-5.8-15.1-17.7-12.7-30.6-10.1 -7.7 1.6-42 11.6-96.1 68.8 -22.5 23.7-37.3 42.6-47.1 57 -6-7.3-12.8-15.2-20-22.3 -22.1-22.1-46.7-37.2-47.7-37.9 -10.3-6.3-23.8-3.1-30.2 7.3 -6.3 10.3-3.1 23.8 7.2 30.2 0.2 0.1 21.4 13.2 39.6 31.5 18.6 18.6 35.5 43.8 35.7 44.1 4.1 6.2 11 9.8 18.3 9.8 1.2 0 2.5-0.1 3.8-0.3 8.6-1.5 15.4-7.9 17.5-16.3 0.1-0.2 8.8-24.3 54.7-72.7 37-39.1 61.7-51.5 70.3-54.9 0.1 0 0.1 0 0.3 0 0 0 0.3-0.1 0.8-0.4 1.5-0.6 2.3-0.8 2.3-0.8 -0.4 0.1-0.6 0.1-0.6 0.1l0-0.1c4-1.7 11.4-4.9 11.5-5C385.4 188.2 389 176.2 384.7 165z" fill="#FFF"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div class="col-10 pl-2">
                                <div class="right">
                                    <p>
                                        Congratulations!! <br>
                                        {{successMessage}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-button">
                        <button @click="closeModal('transferSuccessModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                    </div>
                </div>
            </div>
        </ui-modal>

        <!--UI Modal For Displaying Transfer Failed Message-->
        <ui-modal
                ref="transferFailModal" transition="scale-up"
                :removeHeader= "true" size="small" @hide="endTransfer"
                align-top :align-top-margin="200"
        >
            <div class="notification-modal sm">
                <div class="head">
                    <div class="logo-hold">
                        <div>
                            <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-2">
                                <div class="left">
                                    <div class="status-icon">
                                        <svg class="error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 455.1 455.1">
                                            <circle cx="227.6" cy="227.6" r="227.6" fill="#E24C4B"></circle>
                                            <path d="M455.1 227.6c0 125.2-102.4 227.6-227.6 227.6 -72.5 0-136.5-32.7-177.8-85.3 38.4 31.3 88.2 49.8 142.2 49.8 125.2 0 227.6-102.4 227.6-227.6 0-54-18.5-103.8-49.8-142.2C422.4 91 455.1 155 455.1 227.6z" fill="#D1403F"></path>
                                            <path d="M331.4 331.4c-8.5 8.5-22.8 8.5-31.3 0l-72.5-72.5 -72.5 72.5c-8.5 8.5-22.8 8.5-31.3 0 -8.5-8.5-8.5-22.8 0-31.3l72.5-72.5 -72.5-72.5c-8.5-8.5-8.5-22.8 0-31.3 8.5-8.5 22.8-8.5 31.3 0l72.5 72.5 72.5-72.5c8.5-8.5 22.8-8.5 31.3 0 8.5 8.5 8.5 22.8 0 31.3l-72.5 72.5 72.5 72.5C339.9 308.6 339.9 322.8 331.4 331.4z" fill="#FFF"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div class="col-10 pl-2">
                                <div class="right">
                                    <p>
                                        Failed!! <br>
                                        {{errorMessage}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-button">
                        <button @click="closeModal('transferFailModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                    </div>
                </div>
            </div>
        </ui-modal>

      <!--Account Upgrade Modal-->
      <ui-modal
          ref="accountUpgradeModal" transition="scale-up"
          :removeHeader="true" size="small" @hide="closeAccountUpgradeModal"
          align-top :align-top-margin="50"
      >
        <div class="notification-modal sm">
          <div class="head">
            <div class="logo-hold">
              <div>
                <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
              </div>
            </div>
          </div>

          <div class="bottom">
            <div class="modal-body transaction-pin">



              <div class="row">
                <div class="col-sm-12">
                  <p class="warning-msg">
                    You have to upgrade your account to enable you perform transactions.
                    <br />
                    Kindly upgrade your account on the app and try again.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ui-modal>

    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    import AccountsSelectBox from '../utility/AccountsSelectBox'
    import MobileLeftBar from '../sidebar/MobileLeftBar'
    import FooterMobile from "./FooterMobile";

    export default {
        name: "Confirmation",
        components: {
            FooterMobile,
            mobileLeftBar: MobileLeftBar,
        },
        props: {
        },
        data () {
            return {
                narration: 'Transfer from this to this.',
                savebene: false,
                alias: '',
                passcode: '',

                successMessage: '',
                errorMessage: '',

                transferStatus: 0,
                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getUsername',
                'getDataOnLogin',
                'getFullBankList',
                'getConfirmationPageBody',
                'getIfAccountHasBeenUpgraded'
            ])
        },
        created () {
            this.popDefaultNarration()
        },
        methods: {
            ...mapActions([
                'updateNetworkErrorState',
                'updateAppLoading',
                'updateSideBarPage',
                'updateInsideCurrentPage',
                'updateConfirmationPageBody',
                'updateDataOnLoginAccounts',
                'updateDataOnLoginTransactions',
            ]),

            backButton(){
                if (this.getConfirmationPageBody.transactionType === 'phoneTransfer' || this.getConfirmationPageBody.transactionType === 'phoneTransfer2') {
                    this.updateInsideCurrentPage('phoneTransfer')
                }
                else  if (this.getConfirmationPageBody.transactionType === 'airtime'){
                    this.updateInsideCurrentPage('airtime')
                }
                else  if (this.getConfirmationPageBody.transactionType === 'mobileData'){
                    this.updateInsideCurrentPage('mobileData')
                }
                else  if (this.getConfirmationPageBody.transactionType === 'otherBills'){
                    this.updateInsideCurrentPage('otherBills')
                }
                else {
                    this.updateInsideCurrentPage('fundsTransfer')
                }
            },
            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },

            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },
            clearKeenUiSelect(ref) {
                this.$refs[ref].clearSelection();
            },

            generateUUID() {
                let d = new Date().getTime();
                let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    let r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
                });
                localStorage.test = uuid;
                return uuid
            },
            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            popDebitAcct(){
                let sdat = [];
                let sample = {};

                // // // console.log('ACCOunt ++====>>>', this.getDataOnLogin.accountlist)

                for (let i = 0; i < this.getDataOnLogin.accountlist.length; i++){
                    sample.label = this.getDataOnLogin.accountlist[i].accountno + " - ₦" + this.$options.filters.moneyFormat(this.getDataOnLogin.accountlist[i].availablebalance);
                    sample.value = this.getDataOnLogin.accountlist[i];

                    sdat.push(sample)

                    sample = {}
                }

                this.dat = sdat;
            },
            popFullBankList(){
                let sdat = [];
                let sample = {};

                // // // console.log('ACCOunt ++====>>>', this.getDataOnLogin.accountlist)
                for (let i = 0; i < this.getFullBankList.length; i++){
                    sample.label = this.getFullBankList[i].bankname;
                    sample.value = this.getFullBankList[i];
                    sample.image = "https://s3.amazonaws.com/rubiesstore/"+this.getFullBankList[i].bankcode+".png"

                    sdat.push(sample)
                    sample = {}
                }

                this.fullBankLeest = sdat;
            },

            popDefaultNarration(){
                this.narration = this.getConfirmationPageBody.narration;
            },

        //    pin Modal
            openPinModal(){
              //check if account has been upgraded?
              let upgradeAccount = this.getIfAccountHasBeenUpgraded;
              if (upgradeAccount !== 'N' && upgradeAccount !== 'tier0' && upgradeAccount !== 'tier1.1') {
                //Open The PIn Modal
                this.openModal('pinModal');
              } else {
                this.openAccountUpgradeModal()
              }
            },
            closePinModal(){
                //Close the Pin Modal
                this.closeModal('pinModal')
            },
            openTransferSuccessModal(){
                //Open The TransferSuccessModal
                this.openModal('transferSuccessModal');
            },
            closeTransferSuccessModal(){
                //Close the TransferSuccessModal
                this.closeModal('transferSuccessModal')
            },
            openTransferFailModal(){
                //Open The TransferSuccessModal
                this.openModal('transferFailModal');
            },
            closeTransferFailModal(){
              //Close the TransferSuccessModal
              this.closeModal('transferFailModal')
            },
            openAccountUpgradeModal(){
              //Open The TransferSuccessModal
              this.openModal('accountUpgradeModal');
            },
            closeAccountUpgradeModal(){
              //Close the TransferSuccessModal
              this.closeModal('accountUpgradeModal');
              //Update the current sub component in the store
              this.updateInsideCurrentPage('dashboard')
            },
            tPinInputNo(no){
                // // console.log('tPinInputNo (no) outside > ====>>', no)

                //    input The incoming number
                this.passcode = this.passcode + no;

                // // console.log('tPinInputNo (Passcode) after apend > ====>>', this.passcode)

                //    check if passcode length is up to 6 now
                this.tPinLengthCheck();
            },
            backspace() {
                this.passcode = this.passcode.slice(0, -1);
            },
            clear() {
                this.passcode = '';
            },
            tPinLengthCheck(){
                // // console.log('tPinLengthCheck (passcode) outside > ====>>', this.passcode)

                if (this.passcode.length === 6) {

                    // // console.log('tPinLengthCheck (passcode) inside > ====>>', this.passcode)
                    // consume API or do the next thing
                    this.ConsumeFinalAPI()
                }
            },

            logDataOnLogin(){
                // // console.log('Data On Login Before Update =>>>>', this.getDataOnLogin);
            },
            formatAmountRtn(_incomingAmount){
                if(_incomingAmount.length === 0){
                    _incomingAmount = '0'
                }
                // _incomingAmount = _incomingAmount.replace(/,/g, '');

                let outgoingAmount = this.cleanAmount(_incomingAmount);
                let indexOfThePoint = outgoingAmount.indexOf('.');

                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    return string + this;
                };
                let answer = outgoingAmount
                let count = 0
                for (let i = indexOfThePoint; i >= 1; i--){
                    if(count === 3){
                        count = 1
                        answer = answer.insert(i, ",")
                    }
                    else {
                        count++
                    }
                }

                return answer;
            },
            amountOnChange(_incomingAmount){
                if(_incomingAmount.length === 0){
                    _incomingAmount = '0'
                }
                // _incomingAmount = _incomingAmount.replace(/,/g, '');

                let outgoingAmount = this.cleanAmount(_incomingAmount);
                let indexOfThePoint = outgoingAmount.indexOf('.');

                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    return string + this;
                };
                let answer = outgoingAmount
                let count = 0
                for (let i = indexOfThePoint; i >= 1; i--){
                    if(count === 3){
                        count = 1
                        answer = answer.insert(i, ",")
                    }
                    else {
                        count++
                    }
                }

                this.amount = answer;
            },
            cleanAmount(_amount){
                _amount = _amount.replace(/,/g, '');
                _amount = (parseFloat(_amount).toFixed(2)).toString();

                return _amount
            },
            ConsumeFinalAPI(){
                //start app running
                this.updateAppLoading(true);

                let ref = this.generateUUID() + '-' + this.getDataOnLogin.customerid.replace(/\s/g, '');

                if (this.getConfirmationPageBody.transactionType === 'fundsTransfer' || this.getConfirmationPageBody.transactionType === 'phoneTransfer'){
                    let dataToBeSent = {
                        amount: this.cleanAmount(this.getConfirmationPageBody.amount),
                        draccount: this.getConfirmationPageBody.debitAcct.accountno,
                        draccountname: this.getConfirmationPageBody.debitAcct.accountname,
                        savebene: this.savebene ? 'Y' : 'N',
                        source: "WEB",
                        craccount: this.getConfirmationPageBody.creditAccount,
                        pin: this.passcode,
                        reference: ref,
                        customerid: this.getDataOnLogin.customerid,
                        alias: this.savebene ? this.alias: '',
                        craccountname: this.getConfirmationPageBody.creditAccountName,
                        bankname: this.getConfirmationPageBody.creditBank.bankname,
                        bankcode: this.getConfirmationPageBody.creditBank.bankcode,
                        username: this.getUsername,
                        narration: this.getConfirmationPageBody.narration,
                    };
                    // // console.log('Data To Be Sent =>>>>', dataToBeSent);

                    axios
                        .post('/fundtransfer', dataToBeSent,
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }})
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData = response.data;
                            console.table(responseData);

                            if (responseData.responsecode === '00') {
                                // // console.log('TRANSFER SUCCESS');

                                //hide pin Modal
                                this.closePinModal();

                                // equate the response message and show transferSuccessModal
                                this.successMessage = responseData.responsemessage;
                                this.openTransferSuccessModal();

                                // update dataOnLogin in the store appropriately
                                this.updateDataOnLoginAccounts(responseData.accountlist);
                                this.updateDataOnLoginTransactions(responseData.transactionlist);

                            } else if (responseData.responsecode === '18'){
                                // // console.log('Invalid tPIN');
                                this.passcode = '';

                                // display error notification
                                this.showAlert(true, 'error', responseData.responsemessage)
                            }else {
                                // // console.log('Other Errors');
                                //hide pin Modal
                                this.closePinModal();

                                // Clear the last passcode
                                this.passcode = '';

                                // equate the response message and show transferFailModal
                                this.errorMessage = responseData.responsemessage;
                                this.openTransferFailModal();
                            }
                        })
                        .catch(error => {
                            //stop app running
                            this.updateAppLoading(false);


                            // set network error state to true
                            this.updateNetworkErrorState(true);
                        })
                }
                else if (this.getConfirmationPageBody.transactionType === 'phoneTransfer2'){
                    let dataToBeSent = {
                        customerid: this.getDataOnLogin.customerid,
                        account: this.getConfirmationPageBody.debitAcct.accountno,
                        reason: this.getConfirmationPageBody.narration,
                        mobilenumber: this.getConfirmationPageBody.creditAccount,
                        countrycode: this.getConfirmationPageBody.countrycode,
                        name: this.getConfirmationPageBody.creditAccountName,
                        amount: this.cleanAmount(this.getConfirmationPageBody.amount),
                        pin: this.passcode,
                        reference: ref,
                        username: this.getUsername,
                    };
                    // // console.log('Data To Be Sent =>>>>', dataToBeSent);

                    axios
                        .post('/sendmoneytophone', dataToBeSent,
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }})
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData = response.data;
                            console.table(responseData);

                            if (responseData.responsecode === '00') {
                                // // console.log('TRANSFER SUCCESS');

                                //hide pin Modal
                                this.closePinModal();

                                // equate the response message and show transferSuccessModal
                                this.successMessage = responseData.responsemessage;
                                this.openTransferSuccessModal();

                                // update dataOnLogin in the store appropriately
                                this.updateDataOnLoginAccounts(responseData.accountlist);
                                this.updateDataOnLoginTransactions(responseData.transactionlist);

                            } else if (responseData.responsecode === '18'){
                                // // console.log('Invalid tPIN');
                                this.passcode = '';

                                // display error notification
                                this.showAlert(true, 'error', responseData.responsemessage)
                            }else {
                                // // console.log('Other Errors');
                                //hide pin Modal
                                this.closePinModal();

                                // Clear the last passcode
                                this.passcode = '';

                                // equate the response message and show transferFailModal
                                this.errorMessage = responseData.responsemessage;
                                this.openTransferFailModal();
                            }
                        })
                        .catch(error => {
                            //stop app running
                            this.updateAppLoading(false);

                            // set network error state to true
                            this.updateNetworkErrorState(true);
                        })
                }
                else if (this.getConfirmationPageBody.transactionType === 'airtime'){
                    let dataToBeSent = {
                        amount: this.cleanAmount(this.getConfirmationPageBody.amount),
                        draccount: this.getConfirmationPageBody.debitAcct.accountno,
                        savebene: this.savebene ? 'Y' : 'N',
                        source: "WEB",
                        billercustomerid: this.getConfirmationPageBody.creditAccount,
                        pin: this.passcode,
                        requestid: ref,
                        customerid: this.getDataOnLogin.customerid,
                        alias: this.savebene ? this.alias: '',
                        draccountname: this.getConfirmationPageBody.debitAcct.accountname,
                        billername: this.getConfirmationPageBody.network.value,
                        username: this.getUsername,
                    };

                    // // console.log('Data To Be Sent =>>>>', dataToBeSent);

                    axios
                        .post('/airtimerecharge', dataToBeSent,
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }})
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData = response.data;
                            console.table(responseData);

                            if (responseData.responsecode === '00') {
                                // // console.log('TRANSFER SUCCESS');

                                //hide pin Modal
                                this.closePinModal();

                                // equate the response message and show transferSuccessModal
                                this.successMessage = responseData.responsemessage;
                                this.openTransferSuccessModal();

                                // update dataOnLogin in the store appropriately
                                this.updateDataOnLoginAccounts(responseData.accountlist);
                                this.updateDataOnLoginTransactions(responseData.transactionlist);

                            } else if (responseData.responsecode === '18'){
                                // // console.log('Invalid tPIN');
                                this.passcode = '';

                                // display error notification
                                this.showAlert(true, 'error', responseData.responsemessage)
                            }else {
                                // // console.log('Other Errors');
                                //hide pin Modal
                                this.closePinModal();

                                // Clear the last passcode
                                this.passcode = '';

                                // equate the response message and show transferFailModal
                                this.errorMessage = responseData.responsemessage;
                                this.openTransferFailModal();
                            }
                        })
                        .catch(error => {
                            //stop app running
                            this.updateAppLoading(false);

                            // set network error state to true
                            this.updateNetworkErrorState(true);
                        })
                }
                else if (this.getConfirmationPageBody.transactionType === 'mobileData'){
                    let dataToBeSent = {
                        amount: this.cleanAmount(this.getConfirmationPageBody.amount),
                        productcode: this.getConfirmationPageBody.bundle.value.productcode,
                        draccount: this.getConfirmationPageBody.debitAcct.accountno,
                        savebene: this.savebene ? 'Y' : 'N',
                        source: "WEB",
                        billercustomerid: this.getConfirmationPageBody.creditAccount,
                        pin: this.passcode,
                        requestid: ref,
                        customerid: this.getDataOnLogin.customerid,
                        alias: this.savebene ? this.alias: '-',
                        draccountname: this.getConfirmationPageBody.debitAcct.accountname,
                        billercode: this.getConfirmationPageBody.biller[0],
                        billername: this.getConfirmationPageBody.biller[1],
                        username: this.getUsername,
                    };


                    // // console.log('Data To Be Sent =>>>>', dataToBeSent);

                    axios
                        .post('/mobiledatarecharge', dataToBeSent,
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }})
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData = response.data;
                            console.table(responseData);

                            if (responseData.responsecode === '00') {
                                // // console.log('TRANSFER SUCCESS');

                                //hide pin Modal
                                this.closePinModal();

                                // equate the response message and show transferSuccessModal
                                this.successMessage = responseData.responsemessage;
                                this.openTransferSuccessModal();

                                // update dataOnLogin in the store appropriately
                                this.updateDataOnLoginAccounts(responseData.accountlist);
                                this.updateDataOnLoginTransactions(responseData.transactionlist);

                            } else if (responseData.responsecode === '18'){
                                // // console.log('Invalid tPIN');
                                this.passcode = '';

                                // display error notification
                                this.showAlert(true, 'error', responseData.responsemessage)
                            }else {
                                // // console.log('Other Errors');
                                //hide pin Modal
                                this.closePinModal();

                                // Clear the last passcode
                                this.passcode = '';

                                // equate the response message and show transferFailModal
                                this.errorMessage = responseData.responsemessage;
                                this.openTransferFailModal();
                            }
                        })
                        .catch(error => {
                            //stop app running
                            this.updateAppLoading(false);


                            // set network error state to true
                            this.updateNetworkErrorState(true);
                        })
                }
                else if (this.getConfirmationPageBody.transactionType === 'otherBills'){
                    let pin = this.passcode

                    // // console.log('PRATATATTAATTATA===>>', this.passcode);
                    // // console.log('PRATATATTAATTATA===>>', this.getConfirmationPageBody);


                    let dataToBeSent = {
                        amount: this.cleanAmount(this.getConfirmationPageBody.amount),
                        draccount: this.getConfirmationPageBody.debitAcct.accountno,
                        draccountname: this.getConfirmationPageBody.debitAcct.accountname,
                        savebene: this.savebene ? 'Y' : 'N',
                        source: "WEB",
                        billercustomerid: this.getConfirmationPageBody.stage3Response.customerId,
                        pin: this.passcode,
                        requestid: ref,
                        customerid: this.getDataOnLogin.customerid,
                        alias: this.savebene ? this.alias: '-',
                        billername: this.getConfirmationPageBody.biller.value[1],
                        billercustomername: this.getConfirmationPageBody.debitAcct.accountname,
                        paymentitemcode: this.getConfirmationPageBody.product.value[0],
                        billerproduct: this.getConfirmationPageBody.product.value[1],
                        username: this.getUsername,
                    };

                    // // console.log('Data To Be Sent =>>>>', dataToBeSent);

                    axios
                        .post('/billerpayment', dataToBeSent,
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }})
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData = response.data;
                            console.table(responseData);

                            if (responseData.responsecode === '00') {
                                // // console.log('TRANSFER SUCCESS');

                                //hide pin Modal
                                this.closePinModal();

                                // equate the response message and show transferSuccessModal
                                this.successMessage = responseData.responsemessage;
                                this.openTransferSuccessModal();

                                // update dataOnLogin in the store appropriately
                                this.updateDataOnLoginAccounts(responseData.accountlist);
                                this.updateDataOnLoginTransactions(responseData.transactionlist);

                            }
                            else if (responseData.responsecode === '18'){
                                // // console.log('Invalid tPIN');
                                this.passcode = '';

                                // display error notification
                                this.showAlert(true, 'error', responseData.responsemessage)
                            }
                            else {
                                // // console.log('Other Errors');
                                //hide pin Modal
                                this.closePinModal();

                                // Clear the last passcode
                                this.passcode = '';

                                // equate the response message and show transferFailModal
                                this.errorMessage = responseData.responsemessage;
                                this.openTransferFailModal();
                            }
                        })
                        .catch(error => {
                            //stop app running
                            this.updateAppLoading(false);

                            // set network error state to true
                            this.updateNetworkErrorState(true);
                        })
                }


            },

            endTransfer(){
                // // console.log('Success Modal Hide')
                //Update the current sub component in the store
                this.updateInsideCurrentPage('dashboard')
            },
        },
        mounted(){
            this.$nextTick(()=>{})
        },
    }
</script>

<style scoped>
    .warning-msg {}
    .btn-xnax {
        margin-top: 5px;
    }
    .save-bene {
        padding: 7px 0 0;
    }
    .num-pad.confirmation-key-pad .key-pad .key-row {
        padding: 0;
    }
    .num-pad.confirmation-key-pad .key-stroke {
        width: 45px;
        height: 45px;
        display: inline-grid;
        padding: 11px 18px;
        margin: 0 13px 13px 0;
        font-size: 17px;
        font-weight: 500;
        border: 0;
        color: #030303;
        fill: #030303;
        background-color: #e4e4e4;
    }
    .num-pad.confirmation-key-pad .key-stroke:hover {
        color: #010101;
        fill: #010101;
        text-decoration: none;
        /*background-color: #6d0605;*/
        background-color: #bababa;
    }
    .setPinBox .pinHolder .pinIndex.active {
        background-color: #030303;
    }
    .setPinBox .pinHolder .pinIndex {
        background-color: #e4e4e4;
    }

    .svgA{fill:none;stroke-width:2;stroke:#FFF;}
</style>